import PageHero from '@/components/feature/PageHero';

export default function ChainHero() {
  return (
    <PageHero
      eyebrow="九畴云铺 · 业务主链"
      title="从一件商品开始"
      titleHighlight="消费 → 数据 → 产业 → 再消费"
      desc="一条贯穿供应商、数字货架、云社员/云店、消费者、平台与产业的业务主链。点击下方「开始演示」，亲眼看一件商品如何跑通全链路。"
      imageUrl="https://readdy.ai/api/search-image?query=Abstract%20business%20chain%20flow%20visualization%20with%20glowing%20connected%20nodes%2C%20deep%20dark%20ink%20navy%20background%2C%20emerald%20and%20gold%20light%20streams%20forming%20a%20horizontal%20value%20chain%2C%20digital%20commerce%20ecosystem%2C%20futuristic%20rural%20economy%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1800&height=1100&seq=jiuchou-chain-01&orientation=landscape"
      imageAlt="九畴云铺 一条业务主链"
      imageTitle="九畴云铺 一条业务主链"
    />
  );
}